mutation UpdateCaseRecord($input: UpdateCaseRecordInput!) {
  updateCaseRecord(input: $input) {
    caseRecord {
      id
    }
  }
}
